import React from 'react'
import { map } from 'lodash'
import { Spinner, ContentSectionBlock, Accordion } from 'camino-react'

import ComplianceIcon from '../ComplianceIcon'
import OnPremIT from '../OnPremIT'
import AssetsTable from './AssetsTable'

function CoverageFields ({ customerContract, loadingAssets, assetRuleTypes, calligoDeviceTypes }) {
  const {
    managed_antivirus: shouldAntivirusBeCovered,
    data_protection_coverage: shouldDataProtectionBeCovered,
    antivirus_product: antivirus,
    backup,
    managed,
  } = customerContract

  return (
    <ContentSectionBlock title='Coverage'>
      <table>
        <thead>
          <tr>
            <th>Antivirus</th>
            <th>Monitoring</th>
            <th>Patching</th>
            <th>Data Protection</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ComplianceIcon boolean={shouldAntivirusBeCovered} tipContent={antivirus} />
            </td>
            <td>
              <ComplianceIcon boolean={managed} />
            </td>
            <td>
              <ComplianceIcon boolean={managed} />
            </td>
            <td>
              <ComplianceIcon boolean={backup} />
            </td>
          </tr>
        </tbody>
      </table>

      <div className='d-flex flex-column'>
        <h3 className='d-flex align-items-center'>
          <span className='mr-3'>Assets</span>
        </h3>

        {loadingAssets && <Spinner width={70} height={70} />}

        {!loadingAssets &&
          (customerContract.service_contract_template_id !== 3 ? (
            <Accordion>
              {map(assetRuleTypes, assetRuleType => ({
                title: assetRuleType.label,
                content: <AssetsTable {...{ assetRuleType }} />
              }))}
            </Accordion>
          ) : (
            <OnPremIT {...{
              calligoDeviceTypes,
              assetRuleTypes,
              agreements: customerContract.agreements
            }}
            />
          ))}
      </div>
    </ContentSectionBlock>
  )
}

export default CoverageFields
